// prod.env.js
module.exports = {
    NODE_ENV: 'stage',
    VUE_APP_API: 'https://tapadmin.stage.cloud.cloudstaff.com',
    VUE_THEME_URL: 'https://static.stage.cloud.cloudstaff.com',
    VUE_APP_ENVIRONMENT: 'stage',
    VUE_APP_UBERAPI: 'https://api-ubertickets.stage.cloud.cloudstaff.com',
    VUE_APP_MAPS: 'AIzaSyB22dqBx_4mcnLY5fg4zAvfl2rzAezBvdc',
    VUE_APP_GOOGLE_CLIENT_ID: '664701702770-opcvplgmjqg0g27aolpuqne3tqju5ond.apps.googleusercontent.com',
    VUE_APP_APPLE_BUNDLE_ID: 'com.cloudstaff.tap',
    VUE_APP_AZURE_CLIENT_ID: '0747846f-56da-493f-8f1d-38007f9c237a',
    VUE_APP_AZURE_TENANT_ID: 'c0199c9d-a154-4cb0-abda-139cd36dc313',
};